import React from 'react';
import PropTypes from 'prop-types';
import PillUser from "../../../../gd-components/molecules/pill/pill-user";

type Props = {
    className   :   string
    disabled?   :   boolean
    size?       :   number
    userId?     :   ID
    palette?    :   string
    onDelete?   :   callback
    onClick?    :   callback
    option?     :   Option
}

export default function FieldUsers_Pill(props: Props) {

    if (!props.option) return null;

    const onClick = () => {
        if(props.onClick && !props.disabled) props.onClick(props.option);
    }

    const onDelete = () => {
        if(props.onDelete && !props.disabled) props.onDelete(props.option);
    }

    // const optionColor = _.get(props.option, 'color', null);

    return (
        <PillUser className =   {props.className}
                  disabled  =   {props.disabled}
                  size      =   {26}
                  userId    =   {props.option.value}
                  palette   =   "gray"
                  onDelete  =   {!!props.onDelete ? onDelete : null}
                  onClick   =   {!!props.onClick ? onClick : null } />
    )

}

FieldUsers_Pill.propTypes = {
    className   : PropTypes.string,

    option      : PropTypes.object,

    onClick     : PropTypes.func,
    onDelete    : PropTypes.func
}
